import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { IconBadge } from '@/components/atoms';

import { regionalCoverage } from '../content';

type Region = (typeof regionalCoverage.regions)[number];

type Props = {
  region: Region;
  index: number;
};

/** A region and the example destinations visitors can ask Kabex about. */
export function RegionalCoverageCard({ region, index }: Props) {
  return (
    <Box
      component="article"
      sx={{
        height: '100%',
        p: { xs: 5, md: 6 },
        border: 1,
        borderColor: 'divider',
        borderRadius: 3,
        bgcolor: 'background.paper',
      }}
    >
      <Stack spacing={4}>
        <Stack direction="row" spacing={4} alignItems="center">
          <IconBadge
            name={index === 0 ? 'location' : 'route'}
            size={48}
            shape="circle"
            tone="tint"
          />
          <Typography variant="h4" component="h3">
            {region.title}
          </Typography>
        </Stack>

        <Typography variant="body2" color="text.secondary">
          Destinations to discuss with our team
        </Typography>

        <Stack direction="row" useFlexGap flexWrap="wrap" gap={2}>
          {region.countries.map((country) => (
            <Chip
              key={country}
              label={country}
              variant="outlined"
              sx={{
                borderColor: 'divider',
                color: 'text.primary',
                bgcolor: 'action.hover',
                '& .MuiChip-label': { px: 3 },
              }}
            />
          ))}
        </Stack>
      </Stack>
    </Box>
  );
}
